import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  rejectBtn: {
    marginRight: 20,
  },
  title: {
    fontSize: 19,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  loader: {
    display: 'block',
  },
}));
